import { useState } from 'react';

import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

import LogOutIcon from '@assets/images/log-out.svg?url';
import LogOutIconHover from '@assets/images/log-out-active.svg?url';
import { useStyles } from './styles/ProfilePopover.styles';
import { UserAvatar } from './UserAvatar';
import { logout } from '@features/redux/store';

interface ProfilePopoverProps {
    anchorEl: any;
    onClose: () => void;
}

export const ProfilePopover = ({ anchorEl, onClose }: ProfilePopoverProps) => {
    const classes = useStyles();

    const [hover, setHover] = useState<boolean>(false);

    const handleLogout = () => logout();

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            className={classes.wrapper}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            <div className={classes.userInfo} onClick={onClose}>
                <div className={classes.itemContainer}>
                    <UserAvatar toggled={true} handleToggleProfile={onClose} />
                </div>

                <div
                    className={classes.itemContainer}
                    onMouseOver={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    onClick={handleLogout}>
                    <div className={classes.icon}>
                        <img src={hover ? LogOutIconHover : LogOutIcon} />
                    </div>

                    <Typography>Logout</Typography>
                </div>
            </div>
        </Popover>
    );
};
